import React from 'react';
import { AddressInfo, AddressStatus } from '../types/address';

interface AddressCardProps {
    status: AddressStatus;
    address?: AddressInfo;
}

export const AddressCard: React.FC<AddressCardProps> = ({ status, address }) => {
    if (status === 'pending') {
        return (
            <div className="glass rounded-3xl p-8 relative overflow-hidden">
                {/* Breathing Glow Border */}
                <div className="absolute inset-0 rounded-3xl border-2 border-blue-500/50 animate-pulse-glow" />

                {/* Content */}
                <div className="relative z-10 flex flex-col items-center justify-center min-h-[200px]">
                    {/* EKG Animation */}
                    <svg
                        className="w-24 h-16 mb-4"
                        viewBox="0 0 100 40"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M0,20 L20,20 L25,10 L30,30 L35,20 L100,20"
                            fill="none"
                            stroke="url(#ekg-gradient)"
                            strokeWidth="2"
                            className="animate-ekg-pulse"
                        />
                        <defs>
                            <linearGradient id="ekg-gradient" x1="0%" y1="0%" x2="100%" y2="0%">
                                <stop offset="0%" stopColor="#3b82f6" />
                                <stop offset="100%" stopColor="#a855f7" />
                            </linearGradient>
                        </defs>
                    </svg>

                    <h3 className="text-xl font-bold text-white mb-2">地址分配中</h3>
                    <p className="text-sm text-gray-400">预计等待时间：2-5分钟</p>
                </div>
            </div>
        );
    }

    if (!address) {
        return null;
    }

    return (
        <div className="glass rounded-3xl p-6 border-2 border-blue-500/20 hover:border-blue-500/40 transition-all duration-300">
            {/* Title */}
            <div className="text-center mb-6">
                <h2 className="text-lg font-bold text-white/90 bg-gradient-to-r from-blue-400 to-purple-400 bg-clip-text text-transparent">
                    {address.title}
                </h2>
            </div>

            {/* Address Lines */}
            <div className="space-y-1 text-left bg-black/30 rounded-xl p-4 font-mono">
                <div className="text-base text-white font-medium">
                    {address.recipientName}
                </div>
                <div className="text-base text-gray-300">
                    {address.line1}
                </div>
                {address.line2 && (
                    <div className="text-base text-gray-300">
                        {address.line2}
                    </div>
                )}
                <div className="text-base text-gray-300">
                    {address.city}, {address.state} {address.zipCode}
                </div>
            </div>
        </div>
    );
};
